import { render, staticRenderFns } from "./ManageEmployers.vue?vue&type=template&id=16ca4698&scoped=true"
import script from "./ManageEmployers.vue?vue&type=script&lang=ts"
export * from "./ManageEmployers.vue?vue&type=script&lang=ts"
import style0 from "./ManageEmployers.vue?vue&type=style&index=0&id=16ca4698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca4698",
  null
  
)

export default component.exports